$(document).ready(function () {
  // CART
  // Open Cart
  $(".ud-toggle-cart").on("click tap", function (e) {
    var headerHeight = $(".ud-cart-header").outerHeight(),
      footerHeight = $(".ud-cart-checkout").outerHeight(),
      height = headerHeight + footerHeight;

    setTimeout(function () {
      //$('.ud-cart-items').css({'height': 'calc(100vh - ' + height + 'px)', 'margin-top': headerHeight + 'px'});
      $("body").toggleClass("ud-cart-open").find(".ud-cart-menu").toggleClass("ud-open");
      $("#navbarContentAlt").collapse("hide");
      // initRipple();
    }, 250);
  });

  // Close Cart
  $(".ud-close-cart").on("click tap", function (e) {
    $(this).closest(".ud-cart-menu").removeClass("ud-open");
    $("body").removeClass("ud-cart-open");
  });

  // Open cart if url contains #CART
  if (window.location.href.includes("#cart")) {
    $(".ud-toggle-cart").first().trigger("click");
  }

  // Swatches
  $(".swatches .color").each(function () {
    if (brightnessByColor($(this).css("background-color")) > 200) {
      $(this).css("box-shadow", "0 0px 3px rgba(0,0,0,0.5)");
    }
  });
  /**
   * Calculate brightness value by RGB or HEX color.
   * @param color (String) The color value in RGB or HEX (for example: #000000 || #000 || rgb(0,0,0) || rgba(0,0,0,0))
   * @returns (Number) The brightness value (dark) 0 ... 255 (light)
   */
  function brightnessByColor(color) {
    var color = "" + color,
      isHEX = color.indexOf("#") == 0,
      isRGB = color.indexOf("rgb") == 0;
    if (isHEX) {
      const hasFullSpec = color.length == 7;
      var m = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);
      if (m)
        var r = parseInt(m[0] + (hasFullSpec ? "" : m[0]), 16),
          g = parseInt(m[1] + (hasFullSpec ? "" : m[1]), 16),
          b = parseInt(m[2] + (hasFullSpec ? "" : m[2]), 16);
    }
    if (isRGB) {
      var m = color.match(/(\d+){3}/g);
      if (m)
        var r = m[0],
          g = m[1],
          b = m[2];
    }
    if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000;
  }

  // FIXED HEADER Watch Fixed Navbar Height and Adjust top padding of MainContent
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.contentRect) {
        $("#MainContent").css("margin-top", entry.contentRect.height);
      }
    }
  });
  resizeObserver.observe($("#HeaderContainer")[0]);

  // Hover Dropdown Menu
  // $('.ud-dropdown-hover').on('mouseenter mouseleave', function(e) {
  //   var parent = $(e.target).closest('.dropdown'),
  //   		menu = parent.children('.dropdown-menu');
  //   parent.addClass('show');
  //   menu.addClass('show');

  //   setTimeout(function() {
  //     parent[parent.is(':hover') ? 'addClass' : 'removeClass']('show');
  //     menu[parent.is(':hover') ? 'addClass' : 'removeClass']('show');
  //     $('[data-toggle="dropdown"]', parent).attr('aria-expanded', parent.is(':hover'));
  //   }, 250);
  // });

  // $('.navbar-toggler').click(function () {
  //   $('body').toggleClass('nav-open');
  // });

  // // Hover Dropdown Menu
  // hoverDropdown()
  // $(window).resize(function () {
  //   hoverDropdown()
  // })

  $("body").on("mouseenter mouseleave", ".dropdown.dropdown-hover", function (e) {
    if ($(window).width() > 992) {
      var _d = $(e.target).closest(".dropdown.dropdown-hover");

      _d.find(".dropdown-toggle").addClass("show");
      _d.find(".dropdown-menu").addClass("show");

      setTimeout(function () {
        _d.find(".dropdown-toggle")[_d.is(":hover") ? "addClass" : "removeClass"]("show");
        _d.find(".dropdown-menu")[_d.is(":hover") ? "addClass" : "removeClass"]("show");
        $('[data-bs-toggle="dropdown"]', _d).attr("aria-expanded", _d.is(":hover"));
      }, 200);
    }
  });

  $("body").on("mouseleave", "nav.navbar", function (e) {
    if ($(window).width() < 992 && $($(".navbar-collapse")[0]).hasClass("show")) {
      $(e.target).click();
    }
  });
});

// function hoverDropdown() {
//   if ($(window).width() >= 992) {
//     $('.ud-dropdown-hover').on('mouseenter mouseleave', function (e) {
//       var parent = $(e.target).closest('.dropdown'),
//         menu = parent.children('.dropdown-menu'),
//         nav = $(".navbar.fixed-top");
//       parent.addClass('show');
//       menu.addClass('show');

//       parent[parent.is(':hover') ? 'addClass' : 'removeClass']('show');
//       menu[parent.is(':hover') ? 'addClass' : 'removeClass']('show');
//       nav[parent.is(':hover') ? 'removeClass' : 'addClass']('start');
//       $('[data-bs-toggle="dropdown"]', parent).attr('aria-expanded', parent.is(':hover'));
//       console.log($('[data-bs-toggle="dropdown"]', parent));

//       // setTimeout(function () {
//       //   parent[parent.is(':hover') ? 'addClass' : 'removeClass']('show');
//       //   menu[parent.is(':hover') ? 'addClass' : 'removeClass']('show');
//       //   nav[parent.is(':hover') ? 'removeClass' : 'addClass']('start');
//       //   $('[data-bs-toggle="dropdown"]', parent).attr('aria-expanded', parent.is(':hover'));
//       //   console.log($('[data-bs-toggle="dropdown"]', parent))
//       // }, 25);

//     });

//   }
// }
